exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-oy_sA{padding:80px 0;max-width:1100px;margin:0 auto;min-height:calc(100vh - 140px)}.main-oy_sA.largeLayout-1ETf6{width:100%;max-width:1300px}.container-bZHn9{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.navigation-DsQ2d{display:none;margin-right:32px}@media screen and (min-width: 992px){.navigation-DsQ2d{display:block;width:calc((100% - 32px)/12*2)}}.content-2xr6y{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}", ""]);

// exports
exports.locals = {
	"main": "main-oy_sA",
	"largeLayout": "largeLayout-1ETf6",
	"container": "container-bZHn9",
	"navigation": "navigation-DsQ2d",
	"content": "content-2xr6y"
};